import {
  Grid,
  Row,
  Col,
  Input,
  Button,
  Table,
  Select,
  Card,
  Modal,
} from "antd";
import { keycloak } from "../utils/keycloak";
import "./LearningGraphTool.css";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import ImageBackground from "../components/LearningGraphTool/ImageBackground";
import LinkOutPurple from "../assets/link-out-purple.png";
import { useMobxStores } from "../stores/stores";
import CreateLearningGraphModal from "../components/CreateLearningGraphModalOneStep";
import { observer } from "mobx-react";
import LearningGraphInfoModal from "../components/LearningGraphInfoModal";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Pagination } from "antd";

const { useBreakpoint } = Grid;

const LearningGraphTool = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("All Levels");

  const screens = useBreakpoint();
  // const isMobile = !screens.sm; // < md = mobile
  const isMobile = !screens.lg;
  const size = () => {
    let size;
    if (screens.xxl) size = "28px";
    else if (screens.xl) size = "20px";
    else if (screens.lg) size = "16px";
    else size = "16px";
    return size;
  };

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { learningGraphStore } = useMobxStores();

  const timeout = useRef(null);

  useEffect(() => {
    if (keycloak.authenticated && searchParams.get("openCreate") === "true") {
      setIsModalOpen(true);
      navigate("/learning-graph-tool", { replace: true });
    }
  }, []);

  useEffect(() => {
    const fetchLearningGraphs = async () => {
      await learningGraphStore.GetLearningGraphs(currentPage);
    };

    fetchLearningGraphs();
  }, []);

  const columns = [
    {
      title: "Learning Topic",
      dataIndex: "learning_topic",
      key: "learning_topic",
      width: "30%",
      render: (item) => (
        <div
          className="table-dark-text"
          style={{
            maxWidth: "90%",
            textAlign: "start",
            margin: "0 auto",
            boxSizing: "border-box",
          }}
          key={item}
        >
          {item}
        </div>
      ),
    },
    {
      title: "Thematic Field",
      width: "14%",

      dataIndex: "thematic_field",
      key: "thematic_field",
      render: (item) => (
        <div className="table-dark-text" key={item}>
          {item}
        </div>
      ),
    },
    {
      title: "Level",
      width: "12%",
      dataIndex: "level",
      key: "level",
      render: (item) => (
        <div
          className="table-dark-text"
          key={item}
          style={{ textTransform: "capitalize" }}
        >
          {item}
        </div>
      ),
    },
    {
      title: "Learning Outcomes",
      width: "36%",
      dataIndex: "educational_outcomes",
      key: "educational_outcomes",
      className: "align-left-column",
      render: (outcomes) => (
        <ul style={{ width: "100%" }}>
          {outcomes?.slice(0, 3).map((item, index) => (
            <li
              className="table-dark-text"
              key={index}
              style={{ textAlign: "start" }}
            >
              {item}
            </li>
          ))}
          {outcomes?.length > 3 && (
            <li className="table-dark-text transparent-marker">...</li>
          )}
        </ul>
      ),
    },

    {
      title: "",
      width: "8%",
      dataIndex: "",
      key: "action",
      render: (_, record) => (
        <EyeOutlined
          style={{ fontSize: "22px", color: "#D01FDF", cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            if (keycloak.authenticated) {
              setSelectedTopic(record.id);
              setIsInfoModalOpen(true);
            } else {
              Modal.confirm({
                title: "Sign in required",
                content:
                  "You are not allowed to perform this action. You need to sign in first.",
                okText: "Sign in",
                cancelText: "Cancel",
                onOk: () =>
                  keycloak.login({ redirectUri: window.location.href }),
              });
            }
          }}
        />
      ),
    },
  ];

  const handleSearch = async (inputValue) => {
    if (inputValue !== "") {
      await learningGraphStore.GetFilteredLearningGraphs(inputValue);
    } else {
      await learningGraphStore.GetLearningGraphs(1);
    }
  };

  const debouncedSearch = (inputValue) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => handleSearch(inputValue), 300);
  };

  const levels = [
    {
      label: "All levels",
      value: "all",
    },
    {
      label: "Beginner",
      value: "beginner",
    },
    {
      label: "Intermediate",
      value: "intermediate",
    },
    {
      label: "Advanced",
      value: "advanced",
    },
    // {
    //   label: "Expert",
    //   value: "expert",
    // },
  ];

  const handleSelectLevel = async (value) => {
    setSelectedLevel(value);
    setSearchInput("");
    if (value === "all") {
      await learningGraphStore.GetLearningGraphs();
    } else {
      await learningGraphStore.GetLearningGraphsByLevel(value);
    }
  };

  const handleDelete = () => {
    setIsInfoModalOpen(false);
    setIsDeleteModalOpen(true);
  };

  const handleCancelDelete = () => {
    setIsInfoModalOpen(true);
    setIsDeleteModalOpen(false);
  };

  return (
    <div className="learning-graph-wrapper">
      {isMobile ? (
        <>
          {" "}
          {/* <ImageBackground /> */}
          <Row style={{ alignItems: "end", marginBottom: "14px" }}>
            <Col span={24}>
              <div
                // className="learning-graph-title "
                className="catalogue-title"
              >
                Learning Path
              </div>
              <div
                // className="learning-graph-heading "
                className="catalogue-heading"
              >
                Discover learning paths created by the XR2Learn Community or
                design your own
              </div>
            </Col>
            <Col span={24} style={{ display: "flex", justifyContent: "end" }}>
              <Button
                // className="add-learning-graph-button"
                style={{ marginTop: "24px", marginBottom: "16px" }}
                className="add-catalogue-button"
                onClick={() => {
                  if (keycloak.authenticated) {
                    setIsModalOpen(true);
                  } else {
                    Modal.confirm({
                      title: "Sign in required",
                      content:
                        "You are not allowed to perform this action. You need to sign in first.",
                      okText: "Sign in",
                      cancelText: "Cancel",
                      onOk: () =>
                        keycloak.login({
                          redirectUri:
                            window.location.origin +
                            "/learning-graph-tool?openCreate=true",
                        }),
                    });
                  }
                }}
              >
                Create
              </Button>
            </Col>
          </Row>
          {/* <Row
            style={{
              justifyContent: "end",
              marginBottom: "18px",
              marginRight: "20px",
            }}
          >
           
          </Row> */}
          <Row gutter={16}>
            <Col span={12}>
              {" "}
              <Input
                style={{
                  height: "36px",
                  // marginRight: "12px",
                  background: "rgba(215, 215, 215, 0.4)",
                  border: "0.2px solid rgba(255, 255, 255, 0.4)",
                  backdropFilter: "blur(15px)",
                  borderRadius: "9px",
                  marginBottom: "12px",
                }}
                // className="learning-graph-search"
                // className="catalogue-search"
                suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
                // placeholder="Search by learning topic"
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  setSelectedLevel("All levels");
                  debouncedSearch(e.target.value);
                }}
                value={searchInput}
              />{" "}
            </Col>
            <Col span={12}>
              <Select
                style={{
                  height: "36px",
                  fontSize: "14px",
                  // minWidth: "100px", width: "46%"
                }}
                value={selectedLevel}
                className="learning-graph-select"
                onChange={(value) => handleSelectLevel(value)}
                defaultValue={"All levels"}
              >
                {levels.map((level, index) => (
                  <Select.Option key={index} value={level.value}>
                    {level.label}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          {/* <Table
            columns={columns}
            dataSource={learningGraphStore?.learningGraphs ?? []}
            // className="learning-graph-tool-table"
            className="catalogue-table"
            pagination={false}
            scroll={{ y: 520 }}
          /> */}
          <Row
            justify={
              learningGraphStore?.learningGraphs.length === 0
                ? "center"
                : "start"
            }
            align={"middle"}
            style={{ width: "100%", margin: "auto" }}
          >
            {learningGraphStore?.learningGraphs.map((item, index) => {
              return (
                <Col justify={"center"} align={"middle"} xs={24}>
                  {index === 0 && learningGraphStore.loadingLastItem ? (
                    <Card
                      className="loading-item-card-learning"
                      key={item.id}
                    ></Card>
                  ) : (
                    <Card
                      className="loading-item-card-learning"
                      style={{ marginTop: "12px" }}
                      key={item.id}
                    >
                      <Row
                        style={{
                          justifyContent: "start",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#000080",
                          }}
                        >
                          {item.learning_topic}
                        </div>
                      </Row>
                      <Row
                        style={{
                          justifyContent: "start",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontSize: "14px",
                            color: "rgba(38, 50, 56, 0.69)",
                          }}
                        >
                          {item.thematic_field}
                        </div>
                      </Row>
                      <Row
                        style={{
                          marginTop: "14px",
                          fontSize: "14px",
                          alignItems: "middle",
                          justifyContent: "space-between",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        >
                          {" "}
                          Level:
                          {" " + item.level}
                        </div>
                        <div>
                          {" "}
                          {/* <LinkOutlined
                            style={{
                              fontSize: size(),
                              color: "#D01FDF",
                              cursor: "pointer",
                              marginRight: "6px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.location.href = `${item.source}`;
                            }}
                          /> */}
                          <EyeOutlined
                            style={{
                              fontSize: size(),
                              color: "#D01FDF",
                              cursor: "pointer",
                            }}
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   navigate(`/catalogue/${item.id}`, {
                            //     state: { backgroundLocation: location },
                            //   });
                            // }}

                            onClick={(e) => {
                              e.stopPropagation();
                              if (keycloak.authenticated) {
                                setSelectedTopic(item.id);
                                setIsInfoModalOpen(true);
                              } else {
                                Modal.confirm({
                                  title: "Sign in required",
                                  content:
                                    "You are not allowed to perform this action. You need to sign in first.",
                                  okText: "Sign in",
                                  cancelText: "Cancel",
                                  onOk: () =>
                                    keycloak.login({
                                      redirectUri: window.location.href,
                                    }),
                                });
                              }
                            }}
                          />
                        </div>
                      </Row>
                    </Card>
                    // <ItemPreview item={item} />
                  )}
                </Col>
              );
            })}

            {learningGraphStore?.learningGraphs.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 16,
                  marginBottom: 80,
                }}
              >
                <Pagination
                  current={currentPage}
                  pageSize={50}
                  total={learningGraphStore.learningCount ?? 0}
                  showSizeChanger={false}
                  showQuickJumper={false}
                  onChange={(
                    page,

                    // nextPageSize
                  ) => {
                    setCurrentPage(page);
                    // setPageSize(nextPageSize);
                    learningGraphStore.GetLearningGraphs(
                      page,
                      // page_size: nextPageSize,
                    );
                  }}
                />
              </div>
            )}

            {learningGraphStore?.learningGraphs.length === 0 && (
              <div></div>
              // <Empty description="No items found" />
            )}
          </Row>
        </>
      ) : (
        <>
          {" "}
          <ImageBackground />
          <Row style={{ alignItems: "end", marginBottom: "68px" }}>
            <Col span={20}>
              <div
                // className="learning-graph-title "
                className="catalogue-title"
              >
                Learning Path
              </div>
              <div
                // className="learning-graph-heading "
                className="catalogue-heading"
              >
                Discover learning paths created by the XR2Learn Community or
                design your own
              </div>
            </Col>
            <Col span={4} style={{ display: "flex", justifyContent: "end" }}>
              <Button
                // className="add-learning-graph-button"
                className="add-catalogue-button"
                onClick={() => {
                  if (keycloak.authenticated) {
                    setIsModalOpen(true);
                  } else {
                    Modal.confirm({
                      title: "Sign in required",
                      content:
                        "You are not allowed to perform this action. You need to sign in first.",
                      okText: "Sign in",
                      cancelText: "Cancel",
                      onOk: () =>
                        keycloak.login({
                          redirectUri:
                            window.location.origin +
                            "/learning-graph-tool?openCreate=true",
                        }),
                    });
                  }
                }}
              >
                Create
              </Button>
            </Col>
          </Row>
          <Row
            style={{
              gap: "8px",
              alignItems: "middle",
              justifyContent: "start",
            }}
          >
            <Input
              style={{ width: "700px", marginRight: "12px" }}
              // className="learning-graph-search"
              className="catalogue-search"
              suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
              placeholder="Search by learning topic"
              onChange={(e) => {
                setSearchInput(e.target.value);
                setSelectedLevel("All levels");
                debouncedSearch(e.target.value);
              }}
              value={searchInput}
            />
            <Select
              value={selectedLevel}
              className="learning-graph-select"
              onChange={(value) => handleSelectLevel(value)}
              defaultValue={"All levels"}
            >
              {levels.map((level, index) => (
                <Select.Option key={index} value={level.value}>
                  {level.label}
                </Select.Option>
              ))}
            </Select>
          </Row>
          <Table
            columns={columns}
            dataSource={learningGraphStore?.learningGraphs ?? []}
            // className="learning-graph-tool-table"
            className="catalogue-table"
            pagination={false}
            // scroll={{ y: 520 }}
            scroll={{ y: "calc(100vh - 320px)" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              height: 80,
            }}
          >
            <Pagination
              current={currentPage}
              pageSize={50}
              total={learningGraphStore.learningCount ?? 0}
              showSizeChanger={false}
              showQuickJumper={false}
              onChange={(
                page,

                // nextPageSize
              ) => {
                setCurrentPage(page);
                // setPageSize(nextPageSize);
                learningGraphStore.GetLearningGraphs(
                  page,
                  // page_size: nextPageSize,
                );
              }}
            />
          </div>
        </>
      )}
      <CreateLearningGraphModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
      <LearningGraphInfoModal
        learningGraphId={selectedTopic}
        isOpen={isInfoModalOpen}
        setIsOpen={setIsInfoModalOpen}
        handleDelete={handleDelete}
        onCheckedMaterialsChange={(id, selected) => {
          console.log("checked materials:", selected);
          learningGraphStore.UpdateLearningGraphProgress(currentPage, id, {
            completed_material_ids: selected,
          });

          // call API here if you want
        }}
      />
      <ConfirmDeleteModal
        learningGraph={selectedTopic}
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        handleCancelDelete={handleCancelDelete}
      />
    </div>
  );
};

export default observer(LearningGraphTool);
